'use client';

import styles from './FormError.module.scss';

export function FormError({message}: {message?: string}) {
  if (!message) return null;
  return <span className={styles.error}>{message}</span>;
}
